// src/pages/ResetPassword.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useStore } from '../store';
import AuthCard, { alertStyle, fullWidthBtn, linkStyle } from '../components/AuthCard';

// Read the token once, then strip it from the address bar so it doesn't linger in
// history or leak through a Referer header.
function takeTokenFromUrl() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  if (token) window.history.replaceState(null, '', window.location.pathname);
  return token;
}

export default function ResetPassword() {
  const navigate = useNavigate();
  const setUser = useStore(s => s.setUser);
  const [token] = useState(takeTokenFromUrl);
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (form.password !== form.confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await authAPI.resetPassword(token, form.password);
      setUser(null); // every session was signed out, including this browser's
      navigate('/login', { replace: true, state: { notice: 'Password updated. Sign in with your new password.' } });
    } catch (err) {
      setError(err.response?.data?.error || 'Could not reset password. Please try again.');
      setLoading(false);
    }
  };

  const footer = <><Link to="/forgot-password" style={linkStyle}>Request a new link</Link> · <Link to="/login" style={linkStyle}>Sign in</Link></>;

  if (!token) {
    return (
      <AuthCard subtitle="Choose a new password" footer={footer}>
        <div style={alertStyle('error')}>This reset link is incomplete. Open the link from your email again, or request a new one.</div>
      </AuthCard>
    );
  }

  return (
    <AuthCard subtitle="Choose a new password" footer={footer}>
      <form onSubmit={submit}>
        {error && <div style={alertStyle('error')}>{error}</div>}
        <div className="form-group">
          <label className="form-label">New password</label>
          <input className="form-input" type="password" autoComplete="new-password" maxLength={72} placeholder="Min 8 characters" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required autoFocus />
        </div>
        <div className="form-group" style={{ marginBottom: 20 }}>
          <label className="form-label">Confirm new password</label>
          <input className="form-input" type="password" autoComplete="new-password" maxLength={72} value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} required />
        </div>
        <button type="submit" className="btn btn-primary" style={fullWidthBtn} disabled={loading}>
          {loading ? 'Saving…' : 'Set new password'}
        </button>
        <p style={{ fontSize: 11, color: '#8892a4', marginTop: 12, textAlign: 'center' }}>
          You'll be signed out on all devices.
        </p>
      </form>
    </AuthCard>
  );
}
